import searchLogo from "../assets/images/searchLogo.svg";
import {
  myValueFormatter_quantity,
  rateFormatter,
} from "./commonFunctions";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import _ from "lodash";
import RecallActivityLink from "../components/RecallActivityLink";

export const BorrowRecallsColDefs = [
  {
    headerName: "Acc Id",
    field: "accountid",
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values))
        return params.values[0];
    },
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 80,
    maxWidth: 80,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
  },
  {
    headerName: "Cusip",
    field: "sec_id",
    floatingFilter: false,
    rowGroup: true,
    enableRowGroup: true,
    sort: "desc",
    filter: "agSetColumnFilter",
    editable: false,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return "(" + _.uniq(params.values).length + ")";
      } else {
        return "(0)";
      }
    },
    comparator: (a: any, b: any, nodeA: any, nodeB: any, isDescending: any) => {
      if (nodeA?.allChildrenCount && nodeB?.allChildrenCount) {
        if (nodeA?.allChildrenCount === nodeB?.allChildrenCount) return 0;
        return nodeA?.allChildrenCount > nodeB?.allChildrenCount ? 1 : -1;
      }
      return;
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 80,
    maxWidth: 80,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Security Name",
    field: "secName",
    floatingFilter: false,
    editable: false,
    hide:true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 200,
    maxWidth: 250,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Ticker",
    field: "ticker",
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values))
        return params.values[0];
    },
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 70,
    maxWidth: 100,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },

  {
    headerName: "Cpty Id",
    field: "cpty_id",
    enableRowGroup: true,
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return "(" + _.uniq(params.values).length + ")";
      } else {
        return "(0)";
      }
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 70,
    maxWidth: 100,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Cpty Name",
    field: "cptyName",
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    hide:true,
    minWidth: 170,
    maxWidth: 250,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "B/L",
    field: "bl",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values))
        return params.values[0];
    },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 55,
    maxWidth: 70,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Activity Type",
    field: "activity_type",
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        let firstType = params.values[0];
        let otherTypes = _.pull(params.values, firstType);
        return _.isEmpty(otherTypes) ? firstType : "Multiple";
      }
      return "Multiple";
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 110,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "ContractId",
    field: "contract_id",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 95,
    maxWidth: 95,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Status",
    field: "status",
    hide:true,
    floatingFilter: false,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        let firstStatus = params.values[0];
        let otherStatuses = _.pull(params.values, firstStatus);
        return _.isEmpty(otherStatuses) ? firstStatus : "";
      }
      return "";
    },
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
        };
    },
    minWidth: 60,
    maxWidth: 140,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "BrwQty",
    field: "borrow_qty",
    aggFunc: "sum",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    filter: "agNumberColumnFilter",
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 75,
    maxWidth: 100,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "RecallQty",
    field: "quantity",
    aggFunc: "sum",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    filter: "agNumberColumnFilter",
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 85,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Rate",
    field: "rate",
    floatingFilter: false,
    filter: "agNumberColumnFilter",
    type: "rightAligned",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid #DFDFDF",
          justifyContent: "flex-end",
        }
    },
    minWidth: 65,
    maxWidth: 100,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
     valueFormatter: rateFormatter
  },
  {
    headerName: "RecallDate",
    field: "recall_date",
    floatingFilter: false,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values))
        return _.min(params.values);
    },
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 98,
    maxWidth: 105,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "BuyInDate",
    field: "buyin_date",
    floatingFilter: false,
    editable: false,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values))
        return _.min(params.values);
    },
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 98,
    maxWidth: 135,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "R/T",
    field: "recall_terminate",
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        let firstType = params.values[0];
        let otherTypes = _.pull(params.values, firstType);
        return _.isEmpty(otherTypes) ? firstType : "";
      }
      return "";
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 55,
    maxWidth: 135,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "RtnQty",
    field: "return_qty",
    aggFunc: "sum",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    filter: "agNumberColumnFilter",
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 75,
    maxWidth: 130,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  
  {
    headerName: "RtnDate",
    field: "return_date",
    floatingFilter: false,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values))
        return _.max(params.values);
    },
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 93,
    maxWidth: 125,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Lender Ref Id",
    field: "lender_ref_id",
    floatingFilter: false,
    editable: false,
    hide: false,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values))
        return _.max(params.values);
    },
    filter: "agSetColumnFilter",
    cellRenderer: RecallActivityLink,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 130,
    maxWidth: 185,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "UpdateBy",
    field: "updated_by",
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        let firstUser = params.values[0];
        let otherUsers = _.pull(params.values, firstUser);
        return _.isEmpty(otherUsers) ? firstUser : "";
      }
      return "";
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 100,
    maxWidth: 135,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "UpdatedDate",
    field: "updatedDate",
    floatingFilter: false,
    editable: false,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values))
        return _.max(params.values);
    },
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 120,
    maxWidth: 135,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Trader",
    field: "trader",
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 100,
    maxWidth: 135,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Created By",
    field: "created_by",
    floatingFilter: false,
    editable: false,
    hide:true,
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 100,
    maxWidth: 135,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Created Date",
    field: "createdDate",
    floatingFilter: false,
    editable: false,
    hide:true,
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 135,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
];
